import axios from "axios"
import { BACKEND_URL } from "./Constant";

export const axiosInstance = axios.create({
    baseURL: BACKEND_URL,
    headers: {'Content-Type': 'application/json', 'Access-Control-Allow-Origin': BACKEND_URL },
    withCredentials: true,
  });
